import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=74b537ee&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b537ee')) {
      api.createRecord('74b537ee', component.options)
    } else {
      api.reload('74b537ee', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=74b537ee&", function () {
      api.rerender('74b537ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Services.vue"
export default component.exports